import { createAjv } from '@jsonforms/core';

/**
 * Shared AJV instance for all <JsonForms> instances.
 *
 * Nexo schemas tag lookup fields with custom string `format`s (entity-lookup / api-lookup /
 * code-lookup). These are pure renderer-selection hints consumed by LookupRenderer — not real
 * JSON Schema formats. Registering them as no-op formats stops AJV from logging
 * "unknown format \"entity-lookup\" ignored ..." for every lookup field, while keeping the
 * format value intact so renderer matching still works.
 *
 * createAjv() reproduces JsonForms' default AJV configuration, so behaviour is unchanged apart
 * from these formats now being recognised.
 */
export const nexoJsonFormsAjv = createAjv();

for (const format of ['entity-lookup', 'api-lookup', 'code-lookup']) {
  nexoJsonFormsAjv.addFormat(format, () => true);
}
